import transactionSession from '../instance';

const closeTransaction = (contextType) => {
  const { context, isDedicated } = transactionSession.get();

  if (contextType !== context) {
    throw new Error('Passed contextType does not match the context of the opened transaction');
  }

  if (isDedicated) {
    transactionSession.clearState();
  } else {
    transactionSession.reset();
  }
};

export default closeTransaction;
